class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        this.close();
      }
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};

    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);

      if (!response.ok) return;

      const cart = await response.json();

      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (error) {
      console.warn('Nie udało się wysłać zdarzenia cart:view.', error);
    }
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!parsedState?.sections) return;

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState.sections[section.id];

      if (!target || !sectionHtml) return;

      const innerHtml = this.getSectionInnerHTML(
        sectionHtml,
        section.selector
      );

      if (innerHtml !== null) {
        target.innerHTML = innerHtml;
      }
    });

    this.removeCartCountFromButton();

    if (this.header && typeof this.header.reveal === 'function') {
      this.header.reveal();
    }

    this.open();
  }

  removeCartCountFromButton() {
    const cartButton = document.getElementById(
      'cart-notification-button'
    );

    if (!cartButton) return;

    cartButton.textContent = 'Pokaż koszyk';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const parsedDocument = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const selectedElement = parsedDocument.querySelector(selector);

    return selectedElement ? selectedElement.innerHTML : null;
  }

  handleBodyClick(event) {
    if (!this.notification) return;

    const target = event.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define(
    'cart-notification',
    CartNotification
  );
}